export enum PlatformMode {
  TestSmarter = 'ts',
  IRhythm = 'ir',
}

// Own localStorage key: survives logout, which drops the persisted redux state.
export const PLATFORM_MODE_STORAGE_KEY = 'platform_mode'

export const PLATFORM_MODE_LABELS: Record<PlatformMode, string> = {
  [PlatformMode.TestSmarter]: 'TestSmarter',
  [PlatformMode.IRhythm]: 'iRhythm',
}

export const PLATFORM_MODE_COLORS: Record<PlatformMode, string> = {
  [PlatformMode.TestSmarter]: '#2c83bd',
  [PlatformMode.IRhythm]: '#9561e2',
}

// DME order list columns that disclose clinical results, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_ORDER_COLUMNS = ['odi', 'ahi', 'oxygenDelivery']

// DME order view tabs that show results, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_ORDER_TABS = ['report', 'oxygenSetup']

// DME order documents that are reports, hidden in iRhythm mode.
export const IRHYTHM_HIDDEN_DME_DOCUMENT_TYPES = ['MOVED_REPORT']

// DME sidebar labels (by menu key) replaced in iRhythm mode.
export const IRHYTHM_DME_MENU_LABELS: Record<string, string> = {
  'hst--report-complete': 'Completed',
}
